// structure of the custom events sent from the front-end to track user interactions
export type UserInteractionEventProperties = {
    applicationType: string;
    userId: string | undefined;
    interactionType: string;
    interactionValue?: string;
    isSuccess?: boolean | undefined;
    error?: string | undefined;
};

// add here the new event properties
export const EventName_UserInteraction = "userInteraction"
export const EventProperty_Value_ApplicationType = "UI"
export const EventProperty_Value_WikiClick = "wikiClick"
export const EventProperty_Value_DeclineToU = "declineToU"
export const EventProperty_Value_UploadDocument = "uploadDocument"
export const EventProperty_Value_SwitchTheme = "switchTheme"
export const EventProperty_Value_FeatureHighlightOpen = "featureHighlightOpen"
export const EventProperty_Value_FeatureHighlightDismiss = "featureHighlightDismiss"
export const EventProperty_Value_PersonalGptUploadDocument = "personalGptUploadDocument"
export const EventProperty_Value_InstallPWA = "installPWA"
export const EventProperty_Value_StartUp = "startUp"
export const EventProperty_Value_MicrophoneClick = "microphoneClick"
